module.exports = __webpack_public_path__ + "img/dingzhi_icon_youxiang.99b43c6d.svg";